import { useScopedSelector } from 'ia-react-core';
import React, { FC, ReactNode, useMemo, useState } from 'react';
import { DictionaryGlobal } from '../../pages/ChangePasswordPage/interfaces/SiteCoreDictionaryInterface';
import DictionaryLoader from '../../pages/ChangePasswordPage/ChangePasswordForm/DictionaryLoader';
import { ChangePasswordPageState } from '../../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';
import ChangePasswordContext from '../../utils/ChangePasswordContext';

export interface ChangePasswordProviderProps {
  children: ReactNode;
}

const ChangePasswordProvider: FC<ChangePasswordProviderProps> = ({ children }) => {
  const [rules, setRules] = useState<ChangePasswordPageState>({
    ErrorMessageText: [],
    isModalOpened: false,
    Regle8CharMin: false,
    Regle3Element: false,
    RegleLettreMinuscules: false,
    RegleLettreMajuscules: false,
    RegleChiffre: false,
    RegleCharSpec: false,
    PasswordStrength: 'PasswordStrengthWeak',
    PasswordStrengthClass: 'PasswordStrenghClassWeak',
  });
  const sitecoreDictionary: DictionaryGlobal = useScopedSelector('SiteCoreDictionary');
  const changePasswordContext = useMemo(() => ({ rules, setRules, sitecoreDictionary }), [rules, setRules, sitecoreDictionary]);
  return (
    <>
      <DictionaryLoader />
      <ChangePasswordContext.Provider value={changePasswordContext}>
        {children}
      </ChangePasswordContext.Provider>
    </>
  );
};

export default ChangePasswordProvider;
